import jsonSchema from '../../../../schemas/schema.json';

export default function getFullSchema(context: { projectRoot: string }) {
  function updateFileProperty(record: Record<string, any>) {
    for (const [key, value] of Object.entries(record)) {
      if (key === 'file' && typeof value === 'object') {
        value['from'] = context.projectRoot;
      } else if (typeof value === 'object' && value !== null) {
        updateFileProperty(value);
      }
    }
  }

  updateFileProperty(jsonSchema);
  return jsonSchema;
}
